import { isNil } from '@lucidlink/tscore';
import { FilespaceEpochError, InternalError } from '#common/types';
import { EpochResponseMsg } from '#websocket/client/proto';
import { ConnectEpochRequest } from './messages/connect';
import { ReportEpochRequest } from './messages/report';
export class EpochProxy {
    client;
    serverSession;
    epochServiceDestinationPath;
    constructor(fsId, client, serverSession) {
        this.client = client;
        this.serverSession = serverSession;
        this.epochServiceDestinationPath = `/${fsId}/EpochService`;
    }
    async connectEpoch(nodeId, clientEpoch) {
        const req = new ConnectEpochRequest(nodeId, clientEpoch, this.epochServiceDestinationPath);
        const res = await this.sendRequest(req);
        if (res.resultCode !== EpochResponseMsg.ResultCode.OK) {
            throw new FilespaceEpochError();
        }
        if (isNil(res.hubConnection)) {
            throw new InternalError("Hub didn't return an epoch connection");
        }
        return res.hubConnection;
    }
    async reportEpoch(nodeId, clientEpoch, clientConnection) {
        const req = new ReportEpochRequest(nodeId, clientEpoch, clientConnection, this.epochServiceDestinationPath);
        const res = await this.sendRequest(req);
        if (res.resultCode !== EpochResponseMsg.ResultCode.OK) {
            throw new FilespaceEpochError();
        }
        if (isNil(res.prevHubEpoch)) {
            throw new InternalError("Hub didn't return previous hub epoch");
        }
        return res.prevHubEpoch;
    }
    async establishSession() {
        if (isNil(this.serverSession)) {
            return undefined;
        }
        return await this.serverSession.getSessionToken();
    }
    async sendRequest(msg) {
        const sessionToken = await this.establishSession();
        return (await this.client.sendRequest(msg, sessionToken));
    }
}
